import React from "react";

import RestrictedView from "./restrictedView";
import { ADMIN_MANAGER } from "../../../redux/actions/config/session";

const OnlyAdmin = (props) => <RestrictedView allowedRoles={ADMIN_MANAGER}>{props?.children}</RestrictedView>;

export default OnlyAdmin;
